import { useEffect, useState } from 'react'
import { fetchCatalog, getProductImageUrl } from '../lib/supabaseClient'

export function useCatalog() {
  const [categories, setCategories] = useState([])
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    async function load() {
      try {
        setLoading(true)
        const data = await fetchCatalog()
        if (cancelled) return
        setCategories(data.categories || [])
        setProducts(data.products || [])
        setError(null)
      } catch (err) {
        console.error('useCatalog error:', err)
        if (!cancelled) setError(err.message)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => { cancelled = true }
  }, [])

  return { categories, products, loading, error, getProductImageUrl }
}

export { getProductImageUrl }
